import React from 'react'
import $ from "jquery"
import { BrowserRouter as Router} from 'react-router-dom'
import DropdownList from './DropdownList'
import '../../assets/common/css/header.less'
import '../../assets/common/css/dropdown.less'
import logo from '../../assets/common/img/logo.png'

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdownMenu: false
    }
    this.navlistTechdemo = [{
      ele: <a href="https://explorer.trias.one" target="_blank" rel="noreferrer">
            <div className="item-icon icon-explorer"></div>
            <div className="item-text">
            Trias Blockchain Explorer
            </div>
          </a>
    }, {
      ele: <a href="https://monitor.trias.one" target="_blank" rel="noreferrer">
            <div className="item-icon icon-monitor"></div>
            <div className="item-text">
            Trias Blockchain Monitor
            </div>
          </a>
    },
    {
      ele: <a href="https://wallet.trias.one" target="_blank" rel="noreferrer">
            <div className="item-icon icon-wallet"></div>
            <div className="item-text">
              Trias Web Wallet
            </div>
          </a>
    },{
      ele: <a href="https://www.trias.one/testnet">
            <div className="item-icon icon-font"></div>
            <div className="item-text">
            Trias ETH Demonstration
            </div>
          </a>
    }
    ]
  }

  componentDidMount() {
    var self = this
    let navMobileClass = '.navbar-menu-mobile'
    /* 点击移动导航栏 */
    $(navMobileClass).click(function () {
      if ($(this).find(".dropdown-list-box").css('display') === "none") { //如果下拉列表未显示
        self.hideAllDropdownList();
        $(this).addClass('open')
      } else { //如果下拉列表已经显示
        $(this).removeClass('open')
      }
    });

    let testnetDropdownClass =  '.dropdown-list.testnet'
    /* 点击移动导航栏中的testnet */
    $(testnetDropdownClass).find('.category').click(function (e) {
      e.stopPropagation()
      e.preventDefault()
      if ($(this).siblings(".dropdown-list-box").css('display') === "none") { //如果下拉列表未显示
        $(this).parent().addClass('open')
        $(".web-support").css('paddingTop','324px')
      } else {
        $(".web-support").css('paddingTop','26px')
        $(this).parent().removeClass('open')
      }
    });
    $(testnetDropdownClass).find('a').click(function (e) {
      e.stopPropagation()
      self.hideAllDropdownList();
      $(this).parent().removeClass('open')
    });
    let url = window.location.href;
    let urlLan = url.substr(url.length-2,2)
    if(urlLan === 'en' || urlLan === 'zh' || urlLan === 'ja' || urlLan === 'ko'){
      this.changeLanguage(urlLan)
    }else{
      this.changeLanguage('en')
    }
  }

  /**
   * 移动端折叠所有下拉列表
   */
  hideAllDropdownList(){
    $(".navbar-menu-mobile").removeClass('open')
  }

  /**
   * Change language
   * @param {String} lang new language
   */
  changeLanguage(lang) {
    this.setState({
      lang: lang
    })
    // sessionStorage.setItem('language',lang)
    this.hideAllDropdownList()
  }

  render() {

    // options for internationalisation
    this.languageList = [{
      ele: <span onClick={()=>this.changeLanguage('zh')} className={this.state.lang==='zh'?'active':''}>
            <i className="fas fa-globe-americas"></i>
            中文
          </span>
    }, {
      ele: <span  onClick={()=>this.changeLanguage('en')} className={this.state.lang==='en'?'active':''}>
            <i className="fas fa-globe-americas"></i>
            English
          </span>
    },  {
      ele: <span  onClick={()=>this.changeLanguage('ja')} className={this.state.lang==='ja'?'active':''}>
            <i className="fas fa-globe-americas"></i>
            日本語
          </span>
    }, {
      ele: <span  onClick={()=>this.changeLanguage('ko')} className={this.state.lang==='ko'?'active':''}>
            <i className="fas fa-globe-americas"></i>
            한국어
          </span>
    }]

    return (

        <Router>
            <div>
              <header className="header">
                <div className="clearfix">
                  <div className="logo">
                      <a href="https://www.trias.one/">
                          <img src={logo} alt="" />
                      </a>
                  </div>
                  <ul className="navbar-menu-pc">
                      <li>
                        <a href="https://www.trias.one/whitepaper" activeclassname="active">Whitepaper</a>
                      </li>
                      <li>
                        <a href="https://www.trias.one/technology" activeclassname="active">Technology</a>
                      </li>
                      <li>
                        <a href="https://www.trias.one/economy" activeclassname="active">Economy</a>
                      </li>
                      <li>
                        <a href="https://www.trias.one/developer" activeclassname="active">Developer</a>
                      </li>
                      <li>
                        <DropdownList
                          listID="navlistTechdemo"
                          itemsToSelect={this.navlistTechdemo}
                          name="Testnet" />
                      </li>
                      <li>
                        <a href="https://www.trias.one/updates" activeclassname="active">Updates</a>
                      </li>
                      <li>
                        <a href="https://www.trias.one/dao" activeclassname="active">Trias DAO</a>
                      </li>
                      <li>
                        <a href="https://grant.trias.one/">Trias Grant</a>
                      </li>
                      <li className="lang">
                        <DropdownList
                            listID="langlist"
                            itemsToSelect={this.languageList}
                            name={<i className="fas fa-globe-americas"></i>} />
                      </li>
                  </ul>
                  <div className="dropdown-list navbar-menu-mobile lang">
                    <i className="fas fa-globe-americas"></i>
                    <i className="fas fa-times close"></i>
                    <div className="dropdown-list-box">
                      <a href="#/" onClick={()=>this.changeLanguage('zh')} className={this.state.lang==='zh'?'active':''}>
                        中文
                      </a>
                      <a href="#/" onClick={()=>this.changeLanguage('en')} className={this.state.lang==='en'?'active':''}>
                        English
                      </a>
                      <a href="#/" onClick={()=>this.changeLanguage('ja')} className={this.state.lang==='ja'?'active':''}>
                        日本語
                      </a>
                      <a href="#/" onClick={()=>this.changeLanguage('ko')} className={this.state.lang==='ko'?'active':''}>
                        한국어
                      </a>
                    </div>
                  </div>
                  <div className="menu-backdrop"></div>
                  <div className="dropdown-list navbar-menu-mobile">
                    <div className="icon-bar"></div>
                    <div className="icon-bar"></div>
                    <div className="icon-bar"></div>
                    <i className="fas fa-times close"></i>
                    <div className="dropdown-list-box">
                      <a href="https://www.trias.one/whitepaper" onClick={()=> this.hideAllDropdownList()} activeclassname="active">
                      Whitepaper
                      </a>
                      <a href="https://www.trias.one/technology" onClick={()=> this.hideAllDropdownList()} activeclassname="active" >
                      Technology
                      </a>
                      <a href="https://www.trias.one/economy" onClick={()=> this.hideAllDropdownList()} activeclassname="active">
                      Economy
                      </a>
                      <a href="https://www.trias.one/developer" onClick={()=> this.hideAllDropdownList()} activeclassname="active">
                      Developer
                      </a>
                      <div className="dropdown-list testnet">
                        <div className="category">
                        Testnet
                          <i className="fas fa-angle-down"></i>
                        </div>
                        <div className="dropdown-list-box dropdown-list-box-inline">
                          <a href="https://explorer.trias.one" target="_blank" rel="noreferrer">
                            <div className="item-icon icon-explorer"></div>
                            <div className="item-text">
                            Trias Blockchain Explorer
                            </div>
                          </a>
                          <a href="https://monitor.trias.one" target="_blank" rel="noreferrer">
                            <div className="item-icon icon-monitor"></div>
                            <div className="item-text">
                            Trias Blockchain Monitor
                            </div>
                          </a>
                          <a href="https://wallet.trias.one" target="_blank" rel="noreferrer">
                            <div className="item-icon icon-wallet"></div>
                            <div className="item-text">
                            Trias Web Wallet
                            </div>
                          </a>
                          <a href="https://www.trias.one/testnet" activeclassname="active" >
                            <div className="item-icon icon-font"></div>
                            <div className="item-text">
                            Trias ETH Demonstration
                            </div>
                          </a>
                        </div>
                      </div>
                      <a href="https://www.trias.one/updates" onClick={()=> this.hideAllDropdownList()} activeclassname="active">
                      Updates
                      </a>
                      <a href="https://www.trias.one/dao" onClick={()=> this.hideAllDropdownList()} activeclassname="active">
                      Trias DAO
                      </a>
                      <a href="https://grant.trias.one/">Trias Grant</a>
                    </div>
                  </div>
                  <div className="menu-backdrop"></div>
                </div>
              </header>
            </div>
        </Router>
    )
  }
};

